import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack, Divider, TextField, Card, CardHeader, CardContent, List } from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import apiPbx from '../../api/pbx';
import apiContact from '../../api/contact';
import { useSnackbar } from 'notistack5';
import { Icon } from '@iconify/react';
import {
    Timeline,
    TimelineDot,
    TimelineItem,
    TimelineContent,
    TimelineConnector,
    TimelineSeparator
} from '@material-ui/lab';
import { fDateTime } from "../../utils/formatTime";
import Scrollbar from "../../components/Scrollbar";
export default function DialogNoteOfCall({ isOpenModalNoteOfCall, handleCloseModalNoteOfCall, callId }) {
    const { enqueueSnackbar } = useSnackbar();
    const [messegesNotes, setMessegesNotes] = useState([]);
    const [newMessageNote, setnewMessegesNote] = useState("");
    const checkNoteOfCall = async () => {
        try {
            const res = await apiContact.show_note_call({ 'callid': callId });
            setMessegesNotes(res.data.data);
        } catch (error) {
            enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        }
    };
    useEffect(() => {
        checkNoteOfCall();
    }, []);

    const handleGetValueNote = (event) => {
        setnewMessegesNote(event.target.value)
    }

    const handleWriteNoteOfCall = async () => {
        try {
            const writeNote = await apiContact.write_note_call_by_callid({ callid: callId, content: newMessageNote });
            if (writeNote.status == 200) {
                enqueueSnackbar("Cập nhật ghi chú thành công!", { variant: 'success' });
                handleCloseModalNoteOfCall();
            }
        } catch (e) {
            enqueueSnackbar(e.response.data.message[0], { variant: 'error' });
        }
    }

    const OrderItem = ({ item, isLast }) => {
        
        const { message, created_at, staff_name, index } = item;
        return (
            <TimelineItem>
                <TimelineSeparator>
                    <TimelineDot
                        color={
                            (index % 4 === 1 && 'primary') ||
                            (index % 4 === 2 && 'success') ||
                            (index % 4 === 3 && 'info') ||
                            (index % 4 === 0 && 'warning') ||
                            'error'
                        }
                    />
                    {isLast ? null : <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent>
                    <Typography variant="subtitle2">{staff_name}</Typography>
                    <Typography variant="body2">{message}</Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                        {created_at}
                    </Typography>
                </TimelineContent>
            </TimelineItem>
        );
    }

    return (
        <>
            <Dialog open={isOpenModalNoteOfCall} onClose={handleCloseModalNoteOfCall} fullWidth>
                <DialogTitle>
                    <Typography sx={{ color: '#303187', fontSize: '20px', fontWeight: 700 }}>{messegesNotes.length > 0 ? "Cập nhật ghi chú" : "Thêm ghi chú"}</Typography>
                </DialogTitle>
                <Divider sx={{ mt: '20px' }} />
                <DialogContent sx={{ mt: 1 }}>
                    <Stack direction={"column"} spacing={1}>
                        <Card
                            sx={{
                                '& .MuiTimelineItem-missingOppositeContent:before': {
                                    display: 'none'
                                },
                                maxHeight: 400,
                                pb: 2
                            }}
                        >
                            <CardHeader title="Lịch sử ghi chú" />
                            <CardContent sx={{ maxHeight: 350, overflowY: "scroll" }}>
                                <Timeline>
                                    {messegesNotes.map((item, index) => {
                                        return (
                                            <OrderItem key={item.title} index={index} item={item} isLast={index === messegesNotes.length - 1} />
                                        )
                                    })}
                                </Timeline>
                            </CardContent>
                        </Card>
                        <TextField
                            multiline
                            fullWidth
                            rows={3}
                            name='messages'
                            placeholder='Nhập nội dung cần ghi chú...'
                            defaultValue={newMessageNote}
                            onChange={(e) => handleGetValueNote(e)}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseModalNoteOfCall} color="primary" variant="contained" startIcon={<Icon icon="ep:close-bold" />}>
                        Đóng
                    </Button>
                    <Button onClick={handleWriteNoteOfCall} color="primary" variant="contained" startIcon={<Icon icon="material-symbols:add-notes-outline" />}>
                        {"Thêm ghi chú"}
                    </Button>
                </DialogActions>
                <Box sx={{ width: "100%" }}>
                    <Box sx={{ height: "15px", width: '75%', float: "right", background: "#41c7f5", clipPath: 'polygon(0 0, 100% 0, 100% 100%, 5% 100%)' }}> </Box>
                    <Box sx={{ height: "15px", width: '40%', background: "red", clipPath: 'polygon(0 0, 93% 0, 100% 100%, 0 100%)' }}> </Box>
                </Box>
            </Dialog>
        </>
    );
}
